module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/images/logo-dc82b4.png";